module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_7",
      "title": "7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-No-Indent-fmtx1"
  }, [_vm._v("The usual suspects proved invaluable in the writing of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thanks to all my friends for being my friends, and helping keep me alive. I love you all.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thank you to the fine folks in the Albuquerque Science Fiction Society and at Archon in St. Louis for your love and support.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thank you, again, to my current fellow writers of Critical Mass: John Jos. Miller, Matt Reiten, Jan Stirling, Steve Stirling, Lauren Teffeau, Emily Mah Tippetts, and Sarena Ulibarri, as well to all the past members who helped the project at every step of the way.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thank you to my agent, Kay McCauley; my editor, Claire Eddy, and her indefatigable assistant, Bess Cozby; and to Richard Anderson, for what might be an even "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("better")]), _vm._v(" cover than the one Walter Jon Williams called “the greatest cover in the history of the Universe.” And to Irene Gallo for getting Richard to do it again.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thanks to David Sidebottom, Lenore Gallegos, and the Jean Cocteau Cinema in Santa Fe for your support.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thanks to Ron Miles, Webmaster Supreme, for resurrecting my website from the dead, again. And to Theresa Hulongbayan and Gwen Whiting for continuing to wrangle the Facebook Dinosaur Lords group!")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thanks to Diane Duane and Thomas Holtz for invaluable advice and information.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("A heartfelt thank you to George R. R. Martin, for so many things.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thank you to my Dinosaur Army for keeping the faith.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Thanks to Wanda Day for being there.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("And as always—thank you for reading.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d01ac2ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0